import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';
import { getClientIp } from '../helpers/ip-address.helper';
import { mapToSecureDocsStatusModel } from '../models/secure-docs-status';

type OpenDocType = 1 | 2 | 3;

const getHeaders = async (extraHeaders = {}) => {
    const ip = await getClientIp();
    return {
        'X-Client-IP': ip,
        ...extraHeaders
    };
};

const getSecureDocsStatus = async (id: any) => {
    const res = await AxiosInstance.get(`${Config.API_URL}/api/v1/user/dashboard/${id}`);
    if (res && res.data) {
        const secureDocsStatusModel = mapToSecureDocsStatusModel(res.data);
        return secureDocsStatusModel;
    }
};

const getSecureDocs = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.get(`${Config.API_URL}/api/v1/user/files/${id}`, { headers });
};

const saveSecureDocs = async (data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/save-doc`, data, { headers });
};

const updateSecureDocs = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.put(`${Config.API_URL}/api/v1/update-doc/${id}`, data, { headers });
};

const deleteSignedSecureDoc = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.delete(`${Config.API_URL}/api/v1/delete-doc/${id}`, { headers });
};

const getSignedSecureDocUpdateInfo = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.get(`${Config.API_URL}/api/v1/doc/${id}`, { headers });
};

const getFileConfigurations = async (id: any, token?: string) => {
    const headers = token ? await getHeaders({
        Authorization: `Bearer ${token}`,
    }) : await getHeaders();
    return AxiosInstance.get(`${Config.API_URL}/api/v1/file/${id}`, { headers });
};

const setFileConfigurations = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/add-config/${id}`, data, { headers });
};

const modifyFileConfigurations = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.put(`${Config.API_URL}/api/v1/modify-config/${id}`, data, { headers });
};

const sendSecureDocOtp = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/signer/sendotp/${id}`, {}, { headers });
};

const sendCompletedSecureDocOtp = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/completed/sendotp/${id}`, {}, { headers });
};

const openSecureDocWithOtp = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/signer/open/${id}`, data, { headers });
};

const markAsCompleted = async (id: any, data: any, token: string) => {
    const headers = await getHeaders({
        Authorization: `Bearer ${token}`,
    });
    return AxiosInstance.post(`${Config.API_URL}/api/v1/mark/element/${id}`, data, { headers });
};

const openCompletedSecureDocWithOtp = async (id: string,type: OpenDocType, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/completed/open/${id}/${type}`,data,{ headers });
};

const downloadCompletedSecureDocWithoutOtp = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/download/owner/${id}`, {}, { headers });
};

const VoidDoc = async (fileId: string, declineMessage: string) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_URL}/api/v1/void/${fileId}`, {message: declineMessage}, { headers });
};

export const SecureDocsService = {
    getSecureDocsStatus,
    getSecureDocs,
    saveSecureDocs,
    updateSecureDocs,
    deleteSignedSecureDoc,
    getSignedSecureDocUpdateInfo,
    getFileConfigurations,
    setFileConfigurations,
    modifyFileConfigurations,
    sendSecureDocOtp,
    sendCompletedSecureDocOtp,
    openSecureDocWithOtp,
    markAsCompleted,
    openCompletedSecureDocWithOtp,
    downloadCompletedSecureDocWithoutOtp,
    VoidDoc
}